export const EmilyAIIcon = () => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="22"
        viewBox="0 0 17 22"
        className="active-icon"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 16.8872C5.749 16.8872 4.13281 14.7992 4.13281 12.2324C4.13281 14.7992 2.51021 16.8872 0.515625 16.8872C2.51021 16.8872 4.13281 18.967 4.13281 21.5338C4.13281 18.967 5.749 16.8872 7.75 16.8872Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2991 8.21488C12.934 8.21488 10.216 4.73879 10.216 0.46582C10.216 4.73879 7.48717 8.21488 4.13281 8.21488C7.48717 8.21488 10.216 11.6772 10.216 15.9502C10.216 11.6772 12.934 8.21488 16.2991 8.21488Z"
          fill="white"
          fillOpacity="0.8"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        className="base"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 16.8872C5.749 16.8872 4.13281 14.7992 4.13281 12.2324C4.13281 14.7992 2.51021 16.8872 0.515625 16.8872C2.51021 16.8872 4.13281 18.967 4.13281 21.5338C4.13281 18.967 5.749 16.8872 7.75 16.8872Z"
          fill="#DE5DC5"
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2991 8.21488C12.934 8.21488 10.216 4.73879 10.216 0.46582C10.216 4.73879 7.48717 8.21488 4.13281 8.21488C7.48717 8.21488 10.216 11.6772 10.216 15.9502C10.216 11.6772 12.934 8.21488 16.2991 8.21488Z"
          fill="#DE5DC5"
          fillOpacity="0.8"
        />
      </svg>
    </span>
  );
};
